import { Component, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexTooltip,
  ApexFill,
  ApexLegend
} from 'ng-apexcharts';
import { Group } from '../data-abstraction/group';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss']
})
export class GraphComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  public pGroup: Group;

  constructor() { }

  ngOnInit(): void {
    const buhoData = localStorage.getItem('buho_data');

    if (buhoData !== undefined) {
      this.pGroup = new Group('', '');
      this.pGroup.deserialize(buhoData);
      const matchings: number[] = new Array();
      const singles: number[] = new Array();
      const names: string[] = new Array();

      for (const student of this.pGroup.student_diagram_data) {
        matchings.push(student['match'])
        singles.push(student['single'])
        names.push(student['name'])
      }


      this.chartOptions = {
        series: [
          {
            name: "Matchningar",
            data: matchings,
            color: 'rgb(129,255,204)'
          },
          {
            name: "Enkla Val",
            data: singles,
            color: 'rgb(153, 204, 255)'
          }
        ],
        chart: {
          type: "bar",
          height: 600,
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        title: {
          text: 'Klass ' + this.pGroup.group_name + ': ' +  this.pGroup.question
        },
        xaxis: {
          categories: names,
          labels: {
            formatter: function(val) {
              return val;
            }
          }
        },
        yaxis: {
          title: {
            text: undefined
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + "";
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40
        }
      };
    }
  }

}
